import React from "react";
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import clsx from "clsx";

/**
 * Pixel-perfect skeleton of UserProfileHeader using react-loading-skeleton.
 */
export default function ProfileHeaderSkeleton({ sidePanel = null }) {
    return (
        <header className="w-full">
            {/* ── MOBILE ── */}
            <div className="lg:hidden">
                {/* Fixed top bar */}
                <div className="fixed top-0 left-0 right-0 z-50 bg-white/90 dark:bg-background-dark/90 backdrop-blur-md h-12 flex items-center justify-between px-2">
                    <div className="flex items-center gap-1">
                        <Skeleton circle width={40} height={40} />
                        <Skeleton width={120} height={20} />
                    </div>
                    <div className="flex items-center gap-1">
                        <Skeleton circle width={36} height={36} />
                        <Skeleton circle width={36} height={36} />
                    </div>
                </div>

                <div className="pt-12 w-full">
                    <div className="relative overflow-hidden bg-white dark:bg-card-dark">
                        <Skeleton height={110} borderRadius={0} />

                        <div className="px-4 -mt-[40px] relative z-10 flex items-center h-[96px] gap-4">
                            <div className="shrink-0">
                                <Skeleton 
                                    circle 
                                    width={80} 
                                    height={80} 
                                    containerClassName="ring-4 ring-white dark:ring-card-dark rounded-full overflow-hidden block" 
                                />
                            </div>

                            <div className="flex-1 min-w-0 self-end h-[40px] flex items-center">
                                {sidePanel}
                            </div>
                        </div>

                        <div className="pb-4" />
                    </div>
                </div>
            </div>

            {/* ── DESKTOP ── */}
            <div className="hidden lg:block lg:pt-2">
                <div className="w-full rounded-lg overflow-hidden border border-gray-100 dark:border-gray-800 bg-white dark:bg-card-dark">
                    <div className="relative">
                        <Skeleton height={159} borderRadius={0} />

                        <div className="absolute top-3 right-3 z-20 flex items-center gap-1.5">
                            <Skeleton width={80} height={36} borderRadius={999} />
                            <Skeleton circle width={36} height={36} />
                        </div>

                        <div className="absolute left-6 -bottom-[76px] z-10">
                            <Skeleton circle width={152} height={152} containerClassName="ring-4 ring-white dark:ring-card-dark rounded-full overflow-hidden block" />
                        </div>
                    </div>

                    <div className="bg-white dark:border-white/5 dark:bg-card-dark pt-4 pb-6 px-6">
                        <div
                            className={clsx(
                                "relative z-10 flex gap-6 items-start",
                                sidePanel ? "pl-[200px] flex-row" : "pl-[200px] flex-col"
                            )}
                        >
                            <div className="min-w-0 flex-1 flex flex-col gap-1.5">
                                <Skeleton width={224} height={28} />
                                <Skeleton width={160} height={24} />
                            </div>

                            {sidePanel && (
                                <div className="relative z-20 shrink-0 self-center flex justify-end">
                                    {sidePanel}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </header>
    );
}
